import React from 'react';
import { useTranslation } from 'react-i18next';
import { X, Power } from 'lucide-react';

const EntityStatusModal = ({
  isOpen,
  onClose,
  onConfirm,
  entityName,
  displayName,
  submitting,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-content max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-yellow-100 text-yellow-700 rounded-lg flex items-center justify-center">
              <Power className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-bold text-gray-900">
              {t('modal.statusChangeTitle')}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="text-gray-600 mb-6">
          <span className="font-semibold text-gray-900">{displayName}</span>{' '}
          {t('modal.statusChangeMessage')} <span className="font-semibold text-gray-900">{entityName}</span>?
        </p>

        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="btn-secondary">
            {t('modal.cancel')}
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting}
            className="btn-primary"
          >
            {submitting ? <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : null}
            {t('modal.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EntityStatusModal;